var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 29.2188V28.0729M36.6667 29.2188V28.0729M18.3333 29.2188V28.0729M27.5 48.125C31.5792 48.125 35.5669 46.9154 38.9586 44.6491C42.3504 42.3828 44.994 39.1616 46.555 35.3929C48.1161 31.6241 48.5245 27.4771 47.7287 23.4763C46.9329 19.4754 44.9685 15.8004 42.0841 12.9159C39.1996 10.0315 35.5246 8.06713 31.5237 7.27131C27.5229 6.47549 23.3759 6.88394 19.6072 8.44499C15.8384 10.0061 12.6172 12.6496 10.3509 16.0414C8.08464 19.4331 6.875 23.4208 6.875 27.5C6.875 30.8 7.64958 33.9167 9.02917 36.6827C10.0673 38.7704 8.62354 41.5869 8.07354 43.6425C7.95169 44.0972 7.95167 44.5759 8.07348 45.0305C8.19529 45.4852 8.43464 45.8997 8.76746 46.2326C9.10028 46.5654 9.51486 46.8047 9.96951 46.9265C10.4242 47.0483 10.9029 47.0483 11.3575 46.9265C13.4131 46.3765 16.2296 44.9327 18.3173 45.9731C21.1699 47.3929 24.3136 48.1296 27.5 48.125Z",
    stroke: "#862B89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.b8c1dd29bb0a75e8ac95fb988503975f.svg";
export { ForwardRef as ReactComponent };